<div *ngIf="type === 'pdf'  ">
  <ngx-extended-pdf-viewer
    class="pdf-viewer-container"
    [src]="'/rest/crm/document/' + document.uuid  + '/image'"
    [backgroundColor]="'#fafafa'"
    [showPresentationModeButton]="false"
    [showPrintButton]="false"
    [showTextEditor]="false"
    [showDownloadButton]="false"
    [showRotateButton]="false"
    [showSecondaryToolbarButton]="false"
    [showDrawEditor]="false"
    [showOpenFileButton]="false"
    [enablePrint]="false"
  ></ngx-extended-pdf-viewer>
</div>

<img *ngIf="type === 'Image'"  class="image-container" [src]="'/rest/crm/document/' + document.uuid + '/image'" alt="Zdjęcie"/>

<div *ngIf="type !== 'pdf' && type !== 'Image'"  class="image-container">
  <h4>Podany typ pliku jest nieobsługiwany </h4>
</div>
